import { render } from "./Ad2.vue?vue&type=template&id=6de7b237&scoped=true"
import script from "./Ad2.vue?vue&type=script&lang=js"
export * from "./Ad2.vue?vue&type=script&lang=js"

import "./Ad2.vue?vue&type=style&index=0&id=6de7b237&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6de7b237"]])

export default __exports__